import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import "./hero.scss";
import BookDemo from "./BookDemo";

function HeroSection() {
    const phoneNumber = "+919158926281"; // Change to your number
    const [show, setShow] = useState(false);

    const [selectedProduct, setSelectedProduct] = useState("");
      
        const openDemo = (product) => {
         setSelectedProduct(product);
         setShow(true);
       };

  return (
    <div className="hero-section d-flex align-items-center text-center text-white">
      <Container>
        <h1 className="fw-bold display-5">
          Transform Your Business with Smart Digital Solutions
        </h1>

        <p className="mt-3 lead">
          Uiplus Technologies is a modern software company established in 2025,
          delivering secure, scalable, and high-performance ERP, web, and mobile solutions.
        </p>

        <div className="mt-4">
          <Button variant="light" className="me-3 px-4" onClick={() => openDemo("Uiplus All Application")}>
            Book Demo
          </Button>
          <Button href={`tel:${phoneNumber}`} variant="outline-light" className="px-4">
            Call Now
          </Button>
        </div>
      </Container>

      {/* <BookDemo show={showDemo} handleClose={() => setShowDemo(false)} /> */}
      <BookDemo
          show={show}
          handleClose={() => setShow(false)}
          productName={selectedProduct}
        />
    </div>
  );
}

export default HeroSection;